import SLATE_NODES from '../../constants/slateNodes';

export default (selectedNodesInCaption) => {
  let citationCount = 0;
  let equationCount = 0;
  selectedNodesInCaption.some((selectedNode) => {
    if (
      selectedNode.type === SLATE_NODES.SPAN &&
      selectedNode.object === SLATE_NODES.INLINE
    ) {
      citationCount = 1;
    }
    if (
      selectedNode.type === SLATE_NODES.IMAGE &&
      selectedNode.data.get('imageType') === SLATE_NODES.EQUATION
    ) {
      equationCount = 1;
    }
    return false;
  });
  return { citationCount, equationCount };
};
